import { render, staticRenderFns } from "./ChannelsList.vue?vue&type=template&id=882a755c&"
import script from "./ChannelsList.vue?vue&type=script&lang=ts&"
export * from "./ChannelsList.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelsList.vue?vue&type=style&index=0&id=882a755c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports